export default "__VITE_ASSET__81ecf128__"